import youngForever from "../../images/Paintings/misc/1_youngForever.jpg";
import upInTheClouds from "../../images/Paintings/misc/2_upInTheClouds.jpg";
import heaven3 from "../../images/Paintings/misc/3_heaven3.jpg";
import heaven2 from "../../images/Paintings/misc/4_heaven2.jpg";
import heavenProgress from "../../images/Paintings/misc/5_heavenProgress.jpg";
import heaven from "../../images/Paintings/misc/6_heaven.jpg";
import hell from "../../images/Paintings/misc/7_hell.jpg";
import hellArtFair from "../../images/Paintings/misc/8_hellArtFair.jpg";
import hellDetail from "../../images/Paintings/misc/9_hellDetail.jpg";
import untitleda from "../../images/Paintings/misc/10_untitled.jpg";
import untitledb from "../../images/Paintings/misc/11_untitled.jpg";
import ihumanDatabase from "../../images/Paintings/misc/12_humanDatabase.jpg";
import jhumanDatabase from "../../images/Paintings/misc/13_humanDatabase.jpg";
import khumanDatabase from "../../images/Paintings/misc/14_humanDatabase.jpg";
import the14thStreetStation from "../../images/Paintings/misc/15_14thStreetStation.jpg";
import inNOutBurger from "../../images/Paintings/misc/16_inNOutBurger.jpg";
import yieldFarmers from "../../images/Paintings/misc/17_yieldFarmers.jpg";
import theWoods from "../../images/Paintings/misc/18_theWoods.jpg";
import ahumanDatabase2 from "../../images/Paintings/misc/19_humanDatabase2.jpg";
import bhumanDatabase2 from "../../images/Paintings/misc/20_humanDatabase2.jpg";
import chumanDatabase2 from "../../images/Paintings/misc/21_humanDatabase2.jpg";
import dhumanDatabase2 from "../../images/Paintings/misc/22_humanDatabase2.jpg";
import ehumanDatabase2 from "../../images/Paintings/misc/23_humanDatabase2.jpg";
import fhumanDatabase2 from "../../images/Paintings/misc/24_humanDatabase2.jpg";
import ghumanDatabase2 from "../../images/Paintings/misc/25_humanDatabase2.jpg";
import hhumanDatabase2 from "../../images/Paintings/misc/26_humanDatabase2.jpg";
import driftingTogether from "../../images/Paintings/misc/27_driftingTogether.jpg";

// 800px responsive versions for srcset
import youngForeverSm from "../../images/Paintings/misc/sm/1_youngForever.jpg";
import upInTheCloudsSm from "../../images/Paintings/misc/sm/2_upInTheClouds.jpg";
import heaven3Sm from "../../images/Paintings/misc/sm/3_heaven3.jpg";
import heaven2Sm from "../../images/Paintings/misc/sm/4_heaven2.jpg";
import heavenProgressSm from "../../images/Paintings/misc/sm/5_heavenProgress.jpg";
import heavenSm from "../../images/Paintings/misc/sm/6_heaven.jpg";
import hellSm from "../../images/Paintings/misc/sm/7_hell.jpg";
import hellArtFairSm from "../../images/Paintings/misc/sm/8_hellArtFair.jpg";
import hellDetailSm from "../../images/Paintings/misc/sm/9_hellDetail.jpg";
import untitledaSm from "../../images/Paintings/misc/sm/10_untitled.jpg";
import untitledbSm from "../../images/Paintings/misc/sm/11_untitled.jpg";
import ihumanDatabaseSm from "../../images/Paintings/misc/sm/12_humanDatabase.jpg";
import jhumanDatabaseSm from "../../images/Paintings/misc/sm/13_humanDatabase.jpg";
import khumanDatabaseSm from "../../images/Paintings/misc/sm/14_humanDatabase.jpg";
import the14thStreetStationSm from "../../images/Paintings/misc/sm/15_14thStreetStation.jpg";
import inNOutBurgerSm from "../../images/Paintings/misc/sm/16_inNOutBurger.jpg";
import yieldFarmersSm from "../../images/Paintings/misc/sm/17_yieldFarmers.jpg";
import theWoodsSm from "../../images/Paintings/misc/sm/18_theWoods.jpg";
import ahumanDatabase2Sm from "../../images/Paintings/misc/sm/19_humanDatabase2.jpg";
import bhumanDatabase2Sm from "../../images/Paintings/misc/sm/20_humanDatabase2.jpg";
import chumanDatabase2Sm from "../../images/Paintings/misc/sm/21_humanDatabase2.jpg";
import dhumanDatabase2Sm from "../../images/Paintings/misc/sm/22_humanDatabase2.jpg";
import ehumanDatabase2Sm from "../../images/Paintings/misc/sm/23_humanDatabase2.jpg";
import fhumanDatabase2Sm from "../../images/Paintings/misc/sm/24_humanDatabase2.jpg";
import ghumanDatabase2Sm from "../../images/Paintings/misc/sm/25_humanDatabase2.jpg";
import hhumanDatabase2Sm from "../../images/Paintings/misc/sm/26_humanDatabase2.jpg";
import driftingTogetherSm from "../../images/Paintings/misc/sm/27_driftingTogether.jpg";

const miscCollection = [
  {
    image: youngForever,
    imageSm: youngForeverSm,
    title: "Young Forever",
    description: "Oil on canvas. 130cm x 220cm. 2009",
    alt: "Young Forever. Oil on canvas. 130cm x 220cm. 2009",
  },
  {
    image: upInTheClouds,
    imageSm: upInTheCloudsSm,
    title: "Up in the clouds",
    description: "Oil & acrylic on canvas. 90cm x 70cm. 2009",
    alt: "Up in the clouds. Oil & acrylic on canvas. 90cm x 70cm. 2009",
  },
  {
    image: heaven3,
    imageSm: heaven3Sm,
    title: "Heaven III",
    description: "Oil on linen. 36cm X 41cm. 2019",
    alt: "Heaven III. Oil on linen. 36cm X 41cm. 2019",
  },
  {
    image: heaven2,
    imageSm: heaven2Sm,
    title: "Heaven II",
    description: "Oil on linen. 36cm X 41cm. 2019",
    alt: "Heaven II. Oil on linen. 36cm X 41cm. 2019",
  },
  {
    image: heavenProgress,
    imageSm: heavenProgressSm,
    title: "Heaven (progress)",
    description: "Oil on linen. (Diptych) 198cm X 304cm. 2019",
    alt: "Heaven. Oil on linen. (Diptych) 198cm X 304cm. 2019",
  },
  {
    image: heaven,
    imageSm: heavenSm,
    title: "Heaven",
    description: "Oil on linen. (Diptych) 198cm X 304cm. 2019",
    alt: "Heaven. Oil on linen. (Diptych) 198cm X 304cm. 2019",
  },
  {
    image: hell,
    imageSm: hellSm,
    title: "Hell",
    description: "Oil on linen. 152cm X 183cm. 2019",
    alt: "Hell. Oil on linen. 152cm X 183cm. 2019",
  },
  {
    image: hellArtFair,
    imageSm: hellArtFairSm,
    title: "Hell(Auckland Art Fair)",
    description: "Oil on linen. 152cm X 183cm. 2019",
    alt: "Hell. Oil on linen. 152cm X 183cm. 2019",
  },
  {
    image: hellDetail,
    imageSm: hellDetailSm,
    title: "Hell(Detail)",
    description: "Oil on linen. 152cm X 183cm. 2019",
    alt: "Hell. Oil on linen. 152cm X 183cm. 2019",
  },
  {
    image: untitleda,
    imageSm: untitledaSm,
    title: "Untitled",
    description: "Oil on board. 20cm X 20cm. 2022",
    alt: "Untitled. Oil on board. 20cm X 20cm. 2022",
  },
  {
    image: untitledb,
    imageSm: untitledbSm,
    title: "Untitled",
    description: "Oil on board. 20cm X 20cm. 2022",
    alt: "Untitled. Oil on board. 20cm X 20cm. 2022",
  },
  {
    image: driftingTogether,
    imageSm: driftingTogetherSm,
    title: "Drifting Together",
    description: "Oil on linen. 51cm X 45.5cm. 2025",
    alt: "Drifting Together. Oil on linen. 51cm X 45.5cm. 2025",
  },
  {
    image: ihumanDatabase,
    imageSm: ihumanDatabaseSm,
    title: "Human Database-NFT collection blueprints",
    description: "Oil on board. 25cm X 25cm. 2021",
    alt: "Human Database. Oil on board. 25cm X 25cm. 2021",
  },
  {
    image: jhumanDatabase,
    imageSm: jhumanDatabaseSm,
    title: "Human Database-NFT collection blueprints",
    description: "Oil on board. 25cm X 25cm. 2021",
    alt: "Human Database. Oil on board. 25cm X 25cm. 2021",
  },
  {
    image: khumanDatabase,
    imageSm: khumanDatabaseSm,
    title: "Human Database-NFT collection blueprints",
    description: "Oil on board. 25cm X 25cm. 2021",
    alt: "Human Database. Oil on board. 25cm X 25cm. 2021",
  },
  {
    image: the14thStreetStation,
    imageSm: the14thStreetStationSm,
    title: "14th Street Station (1/1 NFT)",
    description: "Oil on board + digital drawing. 2022",
    alt: "14th Street Station (1/1 NFT). Oil on board + digital drawing. 2022",
  },
  {
    image: inNOutBurger,
    imageSm: inNOutBurgerSm,
    title: "In-N-Out Burger (1/1 NFT)",
    description: "Oil on board + digital drawing. 2022",
    alt: "In-N-Out Burger (1/1 NFT). Oil on board + digital drawing. 2022",
  },
  {
    image: yieldFarmers,
    imageSm: yieldFarmersSm,
    title: "Yield Farmers (1/1 NFT)",
    description: "Oil on board + digital drawing. 2022",
    alt: "Yield Farmers (1/1 NFT). Oil on board + digital drawing. 2022",
  },
  {
    image: theWoods,
    imageSm: theWoodsSm,
    title: "The Woods (1/1 NFT)",
    description: "Oil on board + digital drawing. 2022",
    alt: "The Woods (1/1 NFT). Oil on board + digital drawing. 2022",
  },
  {
    image: ahumanDatabase2,
    imageSm: ahumanDatabase2Sm,
    title: "Human Database 2-NFT collection",
    description:
      "Digitally hand drawn traits generating 3200 different characters. 2022",
    alt: "Human Database 2- NFTs",
  },
  {
    image: bhumanDatabase2,
    imageSm: bhumanDatabase2Sm,
    title: "Human Database 2-NFT collection",
    description:
      "Digitally hand drawn traits generating 3200 different characters. 2022",
    alt: "Human Database 2- NFTs",
  },
  {
    image: chumanDatabase2,
    imageSm: chumanDatabase2Sm,
    title: "Human Database 2-NFT collection",
    description:
      "Digitally hand drawn traits generating 3200 different characters. 2022",
    alt: "Human Database 2- NFTs",
  },
  {
    image: dhumanDatabase2,
    imageSm: dhumanDatabase2Sm,
    title: "Human Database 2-NFT collection",
    description:
      "Digitally hand drawn traits generating 3200 different characters. 2022",
    alt: "Human Database 2- NFTs",
  },
  {
    image: ehumanDatabase2,
    imageSm: ehumanDatabase2Sm,
    title: "Human Database 2-NFT collection",
    description:
      "Digitally hand drawn traits generating 3200 different characters. 2022",
    alt: "Human Database 2- NFTs",
  },
  {
    image: fhumanDatabase2,
    imageSm: fhumanDatabase2Sm,
    title: "Human Database 2-NFT collection",
    description:
      "Digitally hand drawn traits generating 3200 different characters. 2022",
    alt: "Human Database 2- NFTs",
  },
  {
    image: ghumanDatabase2,
    imageSm: ghumanDatabase2Sm,
    title: "Human Database 2-NFT collection",
    description:
      "Digitally hand drawn traits generating 3200 different characters. 2022",
    alt: "Human Database 2- NFTs",
  },
  {
    image: hhumanDatabase2,
    imageSm: hhumanDatabase2Sm,
    title: "Human Database 2-NFT collection",
    description:
      "Digitally hand drawn traits generating 3200 different characters. 2022",
    alt: "Human Database 2- NFTs",
  },
];

export default miscCollection;
